import React from "react";

import { Stack } from "@mui/material";

import { useDealWorkspace } from "../context/DealWorkspace-context";
import { VirtualizedFolderList } from "./VirtualizedFolderList";

const HEADER_HEIGHT = 36;

interface Props {
  availableHeight?: number;
}

export const CloudMirror: React.FC<Props> = ({ availableHeight = 0 }) => {
  const { cloudMirrorFolders } = useDealWorkspace();

  return (
    <Stack
      sx={{
        width: "100%",
        flexDirection: "column",
        flexShrink: 0
      }}
    >
      <VirtualizedFolderList
        maxHeight={Math.max(0, availableHeight - HEADER_HEIGHT)}
        folderList={cloudMirrorFolders}
        isCloudMirrorFolder={true}
      />
    </Stack>
  );
};
